export const visualVariants: Record<string, { color: string; soft: string; glow: string }> = {
  coral: { color: "#a95464", soft: "#f2d9d9", glow: "rgba(191, 103, 110, .24)" },
  citrus: { color: "#8a7040", soft: "#eee4c9", glow: "rgba(185, 145, 69, .22)" },
  terracotta: { color: "#985844", soft: "#efd8ce", glow: "rgba(172, 90, 61, .2)" },
  tomato: { color: "#8a4b43", soft: "#e9d8cd", glow: "rgba(134, 92, 64, .2)" },
  aubergine: { color: "#6b4059", soft: "#e6d8df", glow: "rgba(107, 64, 89, .2)" },
  wine: { color: "#67293c", soft: "#e5d2d7", glow: "rgba(122, 48, 69, .23)" },
  candlelight: { color: "#6c2739", soft: "#e7c9b6", glow: "rgba(212, 143, 72, .3)" },
  champagne: { color: "#886c46", soft: "#eee2ca", glow: "rgba(197, 157, 90, .25)" },
  cozy: { color: "#765b55", soft: "#e3d1ca", glow: "rgba(156, 106, 94, .2)" },
  surprise: { color: "#5a2a45", soft: "#dfced8", glow: "rgba(122, 48, 69, .26)" },
};
